<div class="modal-header modal-block-primary">
  <button type="button" class="close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Close</span>
  </button>
  <h4 class="modal-title">Add Entry</h4>
</div>
<div class="modal-body">
  <p>Enter processing notes:</p>
  <input
    autofocus
    type="text"
    class="form-control"
    name="notes"
    [(ngModel)]="notes"
    (keydown)="saveOnEnter($event)"
    required
  />
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="saveAddEntry(notes)">Save</button>
  <button type="button" class="btn btn-default" data-dismiss="modal" (click)="modalRef.hide()">
    Cancel
  </button>
</div>
